import { isEmpty } from 'lodash';

import { TableRowData } from '~/core/molecules/Table/types';

export const mapSelectedRows = <T extends TableRowData>(selectedRows: T[] = []): Record<string, boolean> => {
  if (isEmpty(selectedRows)) return {};

  return selectedRows.reduce((acc: Record<string, boolean>, row: T) => {
    acc[String(row.id)] = true;
    return acc;
  }, {});
};
